import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import {
  ATTENDING_FORM,
  SignatureButton,
  VerbalButton,
} from '../../../constants';
import messages from '../CertMessages';
import { LateCertConfirm } from './LateCertConfirm';

const CertButton = ({
  disable,
  endpoint,
  handleCertify,
  message,
  successMessageId,
  smallWidget,
  ...props
}) => (
  <FormattedMessage {...message}>
    {(txt) => (
      <Button
        title={txt}
        size={smallWidget ? 'small' : 'medium'}
        variant="outlined"
        color="primary"
        disabled={disable}
        onClick={handleCertify}
        data-endpoint={endpoint}
        data-successmsg={successMessageId}
        {...props}
      >
        {txt}
      </Button>
    )}
  </FormattedMessage>
);

export const CertificationButtons = ({
  isDoctor,
  canCertify,
  noNarrative,
  submitting,
  handleCertify,
  showVerbal,
  padTop,
  alreadyCertified,
  formType,
  attendingPhysicianId,
  userId,
  smallWidget,
  lateCert,
  pendingCertify,
  setPendingCertify,
}) => {
  const isCertifiedDoctor = isDoctor && canCertify;
  const isDoctorAttendingPhys = attendingPhysicianId === userId;
  const showVerbalByRole =
    formType === ATTENDING_FORM && isDoctorAttendingPhys ? false : showVerbal;
  let certifyMessage;
  if (formType === ATTENDING_FORM) {
    certifyMessage = isDoctorAttendingPhys
      ? messages.Certify
      : messages['nonphys.Certify'];
  } else {
    certifyMessage = isCertifiedDoctor
      ? messages.Certify
      : messages['nonphys.Certify'];
  }

  // OP-33276: on a late cert the Verbal/Sign click is held while the late
  // warning is open (buttons stay visible but disabled) and only reaches
  // handleCertify once the doctor confirms.
  const warningOpen = Boolean(pendingCertify);

  const disableVerbal =
    (isCertifiedDoctor && noNarrative && formType !== ATTENDING_FORM) ||
    submitting ||
    warningOpen;

  const disableSign = !noNarrative || submitting || warningOpen;

  const requestCertify = (e) => {
    if (lateCert) {
      const { endpoint, successmsg } = e.currentTarget.dataset;
      setPendingCertify({ endpoint, successmsg });
    } else {
      handleCertify(e);
    }
  };

  const confirmLate = () => {
    const data = pendingCertify;
    setPendingCertify(null);
    handleCertify(null, data);
  };

  const cancelLate = () => setPendingCertify(null);

  return (
    <Grid
      item
      sm="auto"
      style={padTop ? { paddingTop: 'calc(1rem + 4px)' } : {}}
    >
      {!alreadyCertified && showVerbalByRole ? (
        <CertButton
          disable={disableSign}
          handleCertify={requestCertify}
          message={
            isCertifiedDoctor ? messages.Verbal : messages['nonphys.Verbal']
          }
          endpoint="recordverbal"
          successMessageId="certVerbal"
          style={{ marginRight: '.4rem' }}
          smallWidget={smallWidget}
          // used for selecting the buttons from pop up window for late certs
          id={VerbalButton}
        />
      ) : null}
      {!alreadyCertified && (
        <CertButton
          disable={disableVerbal}
          handleCertify={requestCertify}
          message={certifyMessage}
          endpoint="recordcert"
          successMessageId="Certified"
          smallWidget={smallWidget}
          // used for selecting the buttons from pop up window for late certs
          id={SignatureButton}
        />
      )}
      {lateCert && (
        <LateCertConfirm
          open={warningOpen}
          onConfirm={confirmLate}
          onCancel={cancelLate}
          smallWidget={smallWidget}
        />
      )}
    </Grid>
  );
};

export default CertificationButtons;
